export default "__VITE_ASSET__DTUs_Pv9__"